import React from 'react'
import ModalComponent from '../../../../core/common/modal/ModalComponent'


type props={
    show: boolean,
    handleClose:() => void,
}

const FilterModalContacts=({show,handleClose}:props)=> {
  return (
    <ModalComponent
        modalTitle='Saving Current Filters'
        isVisible={show}
        cancelButton="Cancel"
        onClose={handleClose}
        saveButton='Save'
        className="p-2"

      >
        <>
          <div className="col-md-12">
            <label className="col-form-label">
              Filter Name<span className="text-danger"> *</span>
            </label>
            <input type="text" className="form-control" />
          </div>
        </>

      </ModalComponent>
  )
}

export default FilterModalContacts
